import React from "react";
import DownloadIcon from "./Icons/Download";
import styled, { css } from "styled-components";

const DownloadStyles = styled.a`
  ${({ ...props }) => css`
    display: block;
    margin-top: 48px;
    border-radius: 4px;
    padding: 11px 16px;
    overflow: hidden;
    color: #fff;
    background: #343534;

    &:hover {
      color: #fff;
    }

    img {
      border-radius: 4px;
      overflow: hidden;
      margin-bottom: 16px;
    }

    div {
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      letter-spacing: 0.5px;
      font-size: .75rem;
      text-transform: uppercase;
      font-weight: 700;
      svg {
        margin-right: 16px;
      }

      span > span {
        display: block;
        font-weight: 500;
        text-transform: unset;
        letter-spacing: unset;
      }
    }
  `}
`;

export const ProductDownload = ({ url, label }) => {
  return (
    <DownloadStyles href={url} target="_blank" rel="noreferrer">
      <div>
        <DownloadIcon /> <span>{label || 'Download Spec Sheet'}</span>
      </div>
    </DownloadStyles>
  );
};
